<template>
    <el-dialog
        :title="title"
        width="1000px"
        top="5vh"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        class="create-dialog"
    >
        <el-form
            :model="form"
            :rules="rules"
            label-width="100px"
            class="from"
            ref="ruleForm"
        >
            <el-col :span="11">
                <el-form-item label="模板编码" prop="chooseCode">
                    <el-input
                        :disabled="title !== '新建规则'"
                        v-model.trim="form.chooseCode"
                        autocomplete="off"
                        maxlength="25"
                        clearable
                    >
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
                <el-form-item label="模板名称" prop="chooseName">
                    <el-input
                        v-model.trim="form.chooseName"
                        autocomplete="off"
                        maxlength="25"
                        clearable
                    >
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="是否启用" prop="isUse">
                    <el-select v-model="form.isUse" placeholder="请选择">
                        <el-option label="是" value="0"></el-option>
                        <el-option label="否" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
                <el-form-item label="服务平台" prop="siteName">
                    <advance-dialog
                        v-model="form.siteName"
                        :params="siteParams"
                        :mValue="form.siteName"
                        @getAdvanceValue="getAdvanceValue"
                    >
                    </advance-dialog>
                </el-form-item>
            </el-col>
            <el-col :span="23">
                <el-form-item label="描述" prop="remark">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 1, maxRows: 2 }"
                        v-model.trim="form.remark"
                        autocomplete="off"
                        maxlength="500"
                        show-word-limit
                        clearable
                    >
                    </el-input>
                </el-form-item>
            </el-col>
        </el-form>
        <search-set
            :searchId="searchId"
            ref="searchSet"
            :longPrefix="longPrefix"
            :configurationUrl="configurationUrl"
            :advancePrefix="advancePrefix"
            :popPrefix="popPrefix"
            :searchTotalTitles="searchTotalTitles"
            :searchInitData="searchInitData"
            :id="form.id"
            @search="onSearchChange"
        ></search-set>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button
                v-if="this.title !== '查看规则'"
                type="primary"
                @click="handleSure"
                :loading="loading"
                >确 定</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import searchSet from './searchSet';
import config from './searchInfoConfig';
import { saveDate } from '../../../../api/sieveSingleRule';
import _ from 'lodash';
export default {
    components: { advanceDialog, searchSet },
    data () {
        return {
            form: {
                siteCode: '',
                siteName: '',
                chooseCode: '',
                chooseName: '',
                isUse: '',
                remark: '',
                transportChooseDetails: []
            },
            loading: false,
            siteParams: {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                span: 4,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
            },
            rules: {
                siteName: [
                    { required: true, message: '请选择服务平台', trigger: 'change' }
                ],
                chooseCode: [
                    { required: true, message: '请输入模板编码', trigger: 'blur' }
                ],
                chooseName: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
                isUse: [
                    { required: true, message: '请选择是否启用', trigger: 'change' }
                ]
            },
            searchTotalTitle: config.searchTotalTitle,
            searchInitData: {},
            searchId: 'sieveSingleRule', // 页面ID
            configurationUrl: '/api-auth',
            popPrefix: '/api-mdm/dictionaryDetail/dict',
            advancePrefix: '/api-mdm',
            longPrefix: '/api-gwms/es/comboBox',
            searchTotalTitles: [],
            transportChooseDetails: []

        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新建规则'
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    async created () {
        this.searchTotalTitles = _.cloneDeep(this.searchTotalTitle);
        if (this.title === '编辑规则' || this.title === '查看规则') {
            this.form.siteCode = this.rowData.siteCode;
            this.form.siteName = this.rowData.siteName;
            this.form.chooseCode = this.rowData.chooseCode;
            this.form.chooseName = this.rowData.chooseName;
            this.form.isUse = this.rowData.isUse.toString();
            this.form.remark = this.rowData.remark;
            this.form.id = this.rowData.id;
        }
    },
    methods: {
        // 点击确认时获取自定义单规则结果
        onSearchChange (data) {
            const datas = JSON.parse(JSON.stringify(data));
            const transportChooseDetails = [];
            datas.forEach(item => {
                item.chooseValueCode = this.trim(item.chooseValueCode);
                item.chooseValueMin = this.trim(item.chooseValueMin);
                item.chooseValueName = this.trim(item.chooseValueName);
                if ((item.chooseValueCode && item.chooseValueCode.length) || item.chooseValueMin || item.chooseValueMax) {
                    if (+item.detailType !== 2) {
                        if (item.type === 'select' && (typeof item.chooseValueCode !== 'string')) {
                            item.chooseValueCode = item.chooseValueCode.join(',');
                        }
                        transportChooseDetails.push(
                            {
                                'chooseKey': item.chooseKey,
                                'chooseValue': {
                                    'chooseValueCode': item.chooseValueCode,
                                    'chooseValueName': item.chooseValueName,
                                    'chooseValueDesc': item.name
                                },
                                'detailType': item.detailType // 0等于,1不等于,2范围
                            }
                        );
                    } else {
                        if (item.type === 'time') {
                            item.chooseValueMin = item.chooseValueCode[0];
                            item.chooseValueMax = item.chooseValueCode[1];
                        }
                        transportChooseDetails.push(
                            {
                                'chooseKey': item.chooseKey,
                                'chooseValue': {
                                    'chooseValueMin': item.chooseValueMin,
                                    'chooseValueMax': item.chooseValueMax,
                                    'chooseValueName': item.chooseValueName,
                                    'chooseValueDesc': item.name,
                                    'minSymbol': '>=',
                                    'maxSymbol': '<='

                                },
                                'detailType': item.detailType // 0等于,1不等于,2范围
                            }
                        );
                    }
                }
            });
            transportChooseDetails.forEach(item => {
                item.chooseValue = JSON.stringify(item.chooseValue);
            });
            this.form = {
                ...this.form,
                transportChooseDetails
            };
        },
        // 去除输入空格
        trim (value) {
            if (typeof value === 'string') {
                value = value.replace(/\s*/g, '');
            }
            return value;
        },
        // 获取模板选中数据
        getAdvanceValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        handleClose () {
            this.form = {};
            this.searchTotalTitles = [];
            this.$emit('handleClose');
        },
        handleSure () {
            this.$refs.searchSet.search();
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    saveDate(this.form).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('成功');
                            this.form = {};
                            this.$emit('handleClose', true);
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="less">
.create-dialog {
    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
    .el-date-editor--datetimerange.el-input__inner,
    .el-select {
        width: 100%;
    }
    .from {
        position: relative;
        z-index: 100;
        .el-form-item__label,
        .el-form-item__content {
            line-height: 20px;
        }
    }
    .el-dialog__footer {
        padding: 0px 20px 10px 20px;
    }
}
</style>
